var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirtualTerminal = function SvgVirtualTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.172 4.988 2.89 3.53-2.89 3.53-1.16-.95 2.111-2.58-2.111-2.58 1.16-.95ZM7.008 12.768h7.5v1.5h-7.5v-1.5Z",
    fill: "#1D1737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.592 2.677a.675.675 0 0 0-.675.675v13.056c0 .373.302.675.675.675h13.057a.675.675 0 0 0 .675-.675V3.352a.675.675 0 0 0-.675-.675H3.592Zm.675 13.056V4.027h11.707v11.706H4.267Z",
    fill: "#1D1737"
  })));
};
export default SvgVirtualTerminal;